import { render } from "./TimeBoxesDialog.vue?vue&type=template&id=ef15ba9c&scoped=true&ts=true"
import script from "./TimeBoxesDialog.vue?vue&type=script&lang=ts"
export * from "./TimeBoxesDialog.vue?vue&type=script&lang=ts"

import "./TimeBoxesDialog.vue?vue&type=style&index=0&id=ef15ba9c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef15ba9c"]])

export default __exports__